import { registerPlugin } from '@capacitor/core';

import { GooglePayPlugin as GooglePayPluginInterface } from './google-pay-plugin.types';

export const GooglePayPlugin = registerPlugin<GooglePayPluginInterface>('GooglePay', {
  web: () => import('./google-pay-plugin.web').then((m) => new m.GooglePayPluginWeb()),
  ios: () => import('./google-pay-plugin.ios').then((m) => new m.GooglePayPluginIOS()),
});
